import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemList from '../../../Item-List';
import { Kanban } from 'libs/kanban';

const EctoStatus = ({
  id,
  name: initialName,
  setItems,
  index,
  isNew,
  setSelectedItem,
  setIsOpenModalDelete,
  setStatus,
}) => {
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [name, setName] = useState(initialName);

  const addEctoStatus = async () => {
    const response = await seo.createTypeItem('ecto-status', { name });

    return {
      id: response.id,
      name,
      isNew: false,
    };
  };

  const updateEctoStatus = async () => {
    return await seo.updateTypeItem('ecto-status', id, {
      id,
      name,
    });
  };

  return (
    <ItemList
      id={id}
      initialName={initialName}
      name={name}
      setName={setName}
      setItems={setItems}
      index={index}
      isNew={isNew}
      setSelectedItem={setSelectedItem}
      setIsOpenModalDelete={setIsOpenModalDelete}
      setStatus={setStatus}
      addItem={addEctoStatus}
      updateItem={updateEctoStatus}
      textSaveButton="Add status"
    />
  );
};

EctoStatus.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  setItems: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isNew: PropTypes.bool,
  setSelectedItem: PropTypes.func.isRequired,
  setIsOpenModalDelete: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default EctoStatus;
